module.exports = __webpack_public_path__ + "static/img/31.79dc364.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/food/31.png
// module id = TSze
// module chunks = 1